import { useEffect } from 'react'
import { useMatchScreen } from '../context/MatchScreenContext'
import { trackEvent } from '../utils/tracking/mixpanel'
import { Advisor, AdvisorData } from '../utils/types'

const useTrackContactAdvisorSubmit = () => {
  const { state } = useMatchScreen()
  const { matches, sessionUUID, revisit } = state

  useEffect(() => {
    if (matches && matches.length > 0) {
      if (revisit) {
        const urlSearchParams = new URLSearchParams(window.location.search)
        const sessionId = urlSearchParams.get('s')

        trackEvent('MatchScreen', 'falc-handoff-revisit', {
          page_url: window.location.href,
          s: sessionId
        })
        return
      }

      let hasNonRoboAdvisor = false
      let hasRoboAdvisor = false

      matches.forEach((match: AdvisorData | Advisor) => {
        const advisor: Advisor = 'advisor' in match ? match.advisor : match as Advisor
        if (advisor.format === 'roboadvisor') {
          hasRoboAdvisor = true
        } else if (advisor.format) {
          hasNonRoboAdvisor = true
        }
      })

      if (hasNonRoboAdvisor) {
        trackEvent('MatchScreen', 'contact-advisor-submit', {
          Session_UUID: sessionUUID || '',
          page_url: window.location.href
        })
      }

      if (hasRoboAdvisor) {
        trackEvent('MatchScreen', 'contact-advisor-robo', {
          Session_UUID: sessionUUID || '',
          page_url: window.location.href
        })
      }
    }
  }, [matches, revisit, sessionUUID])
}

export default useTrackContactAdvisorSubmit
